module.exports = __webpack_public_path__ + "fc3fc85e0eab33db43a9cf254530bf40.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/pricing-background.png
// module id = 621
// module chunks = 0